// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const SortOption = t.struct({
    key: t.String,
    order: t.String,
    value: t.String
}, 'SortOption');

export const getDefaultState = () =>
    new SortOption({
        key: '',
        order: '',
        value: ''
    });

export default SortOption;



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/state/sort-option.js